module.exports = __webpack_public_path__ + "img/logo.aafcd300.png";